const BLACKLIST = [
  'backgroundColor',
  'focalPoint',
  'gridColumnGap',
  'hasFocalPoint',
  'isActive',
  'isMobile',
  'isReverse',
  'isSecondary',
  'isSelected',
  'isShortened',
  'ratingBy',
  'search',
  'showBackground',
  'textAlignment',
  'textColor',
  'url',
  'useBackgroundImage',
];
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'prop' implicitly has an 'any' type.
export const shouldForwardProp = (prop) => {
  return !BLACKLIST.includes(prop);
};
